import { usePermissions } from "@/hooks/usePermissions";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { MoreVertical, Eye, Pencil, ClipboardCheck, Trash2, Power, UserPlus } from "lucide-react";

/**
 * Menu de ações de um registro, montado a partir da matriz de permissões do usuário.
 * Só exibe o que ele realmente pode fazer — o backend valida novamente.
 */
export default function RecordActions({
  module, onView, onEdit, onReview, onDelete, onToggle, onAssign, active, testId = "record",
}) {
  const { can } = usePermissions();
  const items = [];
  if (onView && can(module, "view")) items.push({ key: "view", label: "Visualizar", icon: Eye, fn: onView });
  if (onEdit && can(module, "edit")) items.push({ key: "edit", label: "Editar", icon: Pencil, fn: onEdit });
  if (onAssign && can(module, "assign")) items.push({ key: "assign", label: "Delegar", icon: UserPlus, fn: onAssign });
  if (onReview && can(module, "review")) items.push({ key: "review", label: "Revisar", icon: ClipboardCheck, fn: onReview });
  if (onToggle && can(module, active === false ? "activate" : "deactivate"))
    items.push({ key: "toggle", label: active === false ? "Ativar" : "Desativar", icon: Power, fn: onToggle });
  if (onDelete && can(module, "delete"))
    items.push({ key: "delete", label: "Excluir", icon: Trash2, fn: onDelete, danger: true });

  if (items.length === 0) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8" onClick={(e) => e.stopPropagation()}
          data-testid={`actions-${testId}`}>
          <MoreVertical size={15} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        {items.map(({ key, label, icon: Icon, fn, danger }) => (
          <DropdownMenuItem key={key} onClick={(e) => { e.stopPropagation(); fn(); }}
            className={danger ? "text-destructive focus:text-destructive" : ""}
            data-testid={`action-${key}-${testId}`}>
            <Icon size={14} className="mr-2" /> {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
